module.exports = __webpack_public_path__ + "b73b95039218d58bcbefb275d4ba9ed7.png";